module.exports = "/static/assets/06f3b7203e7424adb8a255f708d690b1.png";